// Shared by the full-page form and legacy native SDK form. No work on render.
export function createNewsletterIntent(getIdentity = () => window.MillaAuth?.identity) {
  let formInstanceId = `frm_${randomId()}`;
  let token = null;
  let tokenAt = 0;
  let pending = null;
  let submission = null;
  let fingerprint = null;
  let generation = 0;
  function acquire() {
    if (token && Date.now() - tokenAt < 10 * 60 * 1000) return Promise.resolve(token);
    if (pending) return pending;
    const current = generation;
    pending = new Promise((resolve) => {
      let finished = false;
      const finish = (value) => {
        if (finished) return;
        finished = true;
        clearTimeout(timer);
        if (current === generation) {
          pending = null;
          if (value) { token = value; tokenAt = Date.now(); }
        }
        resolve(current === generation ? value : null);
      };
      const timer = setTimeout(() => finish(null), 700);
      Promise.resolve().then(() => getIdentity()?.requestEmailHandoff?.({ flow: 'NEWSLETTER', formInstanceId }))
        .then((value) => finish(typeof value === 'string' && /^[A-Za-z0-9_-]{43}$/.test(value) ? value : null), () => finish(null));
    });
    return pending;
  }
  function reset() {
    generation++;
    pending = null;
    token = null;
    tokenAt = 0;
    submission = null;
    fingerprint = null;
    formInstanceId = `frm_${randomId()}`;
  }
  function submissionId(payload) {
    const next = JSON.stringify(payload);
    if (fingerprint && fingerprint !== next) reset();
    fingerprint = next;
    submission ||= randomId();
    return submission;
  }
  return { acquire, prefetchOnIntent: () => { void acquire(); }, submissionId, reset };
}
function randomId() {
  return globalThis.crypto?.randomUUID?.() || `${Math.random().toString(36).slice(2)}${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`;
}
